export const LEGAL_ENTITY = {
  TYPE: {
    COMPANY: 'company',
    INDIVIDUAL: 'individual',
    TRUST: 'trust',
  },
}
